import {h} from 'preact';

export default function InfoMessage({text}) {
	return (
		<div class="eds-c-status-message eds-c-status-message--small eds-c-status-message--info u-padding-none">
      <span class="u-icons eds-c-status-message__icon">
      	<svg aria-hidden="true" aria-label="info">
      		<use href="/static/img/svg-sprite.svg#info"></use>
      	</svg>
      </span>
			<div class="eds-c-status-message__message" tabindex="-1" data-testid="">
				{text}
			</div>
		</div>
	);
}
